import React from "react";
import { filterNames } from "../../utils/constants";
import { useDispatch, useSelector } from "react-redux";
import Alert from "../../components/alert";
import { hideAlertEd1 } from "../../redux/actions/ed1AndEd2";
import Spinner from "../../components/presentationals/Spinner";
import PerformanceDetails from "./performanceDetails";
import LinksByPlan from "./linksByPlan";

const WireLineJioFiberView = (props) => {
  const dispatch = useDispatch();
  const { getAllAPI, ed1Modules, ed1Tiles, fetchWirelinePlanCsvApi } = props;
  const {
    showAlert,
    showDateAlert,
    showErrorAlert,
    wirelineAch,
    wirelinePlanCount,
    csvLoading,
  } = useSelector((state) => state.Ed1AndEd2Reducer);
  return (
    <div>
      <h2
        className="pagetitle wow fadeInUp"
        data-wow-delay=".5s"
        data-wow-duration="0.7s"
      >
        {ed1Modules?.modSecMasterTxDtos?.[0]?.sectionName ?? ""}
      </h2>
      <Alert
        showAlert={showAlert}
        showDateAlert={showDateAlert}
        showError={showErrorAlert}
        hideAlert={() => dispatch(hideAlertEd1())}
      />
      {getAllAPI && getAllAPI.loading ? (
        <Spinner />
      ) : ed1Modules?.isModuleActive === "Y" ? (
        <>
          <>
            {ed1Tiles?.[0]?.isTileActive === "Y" ? (
              <PerformanceDetails
                data={ed1Tiles[0]}
                wirelineAch={wirelineAch}
                fetchWirelinePlanCsvApi={fetchWirelinePlanCsvApi}
                csvLoading={csvLoading}
              />
            ) : null}
          </>
          <>
            {ed1Tiles?.[1]?.isTileActive === "Y" ? (
              <LinksByPlan
                data={ed1Tiles[1]}
                wirelinePlanCount={wirelinePlanCount}
              />
            ) : null}
          </>
        </>
      ) : null}
    </div>
  );
};

export default WireLineJioFiberView;
